import script from "./StatusDetailModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatusDetailModal.vue?vue&type=script&lang=ts&setup=true"

import "./StatusDetailModal.vue?vue&type=style&index=0&id=c3eaa3de&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3eaa3de"]])

export default __exports__